import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import Anchor from '../../../../../components/link/Anchor';
import { WIDGET_EDIT_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { WIDGET_LAYOUT_TYPE_TEXT, WIDGET_TYPE_TEXT } from '../../../../../constants/service/app/widgetConstants';
import { openNewWindow, setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { setWidgetExposurePeriod } from '../../../../../lib/utils/widgetUtils';

/**
 *  위젯 컬림
 */
export const columns = (data) => {
  const { getWidgetPreviewData } = data;

  return [
    {
      title: <TableColumnTitle title={'위젯 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(WIDGET_EDIT_URL_PATH, value))}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'위젯 타입'} />,
      dataIndex: 'widgetType',
      render: (value, record) => (
        <Anchor
          color="primary"
          isUnderLine
          text={WIDGET_TYPE_TEXT[value]}
          onClick={() =>
            getWidgetPreviewData({
              widgetId: record.id,
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'레이아웃 타입'} />,
      dataIndex: 'layoutType',
      render: (value, record) => WIDGET_LAYOUT_TYPE_TEXT[record.widgetType][value],
    },
    {
      title: <TableColumnTitle title={'메인 타이틀'} />,
      dataIndex: 'mainTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'서브 타이틀'} />,
      dataIndex: 'subTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      ellipsis: true,
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'노출기간'} />,
      dataIndex: 'exposurePeriod',
      render: (value, record) => setWidgetExposurePeriod(record.exposureStartDate, record.exposureEndDate),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
